import * as React from "react"
import { graphql } from "gatsby"
import { Link, useTranslation } from "gatsby-plugin-react-i18next"
import { DiscussionEmbed } from "disqus-react"

import Bio from "../components/bio"
import Layout from "../components/layout"
import Seo from "../components/seo"

const BlogPostTemplate = ({ data, location }) => {
  const {
    markdownRemark: post,
    previous,
    next,
    site: {
      siteMetadata: {
        title: siteTitle = `Title`,
        social: { disqusShortName } = {},
      } = {},
    },
  } = data
  const { title, description, date } = post.frontmatter
  const { fields: { slug, language } = {} } = post
  const disqusConfig = {
    shortname: disqusShortName,
    config: { identifier: slug, title },
  }

  return (
    <Layout location={location} title={siteTitle}>
      <Seo title={title} description={description || post.excerpt} />
      <article
        className="blog-post"
        itemScope
        itemType="http://schema.org/Article"
      >
        <header>
          {/*<h1 itemProp="headline">{title}</h1>*/}
          <p>{language ? new Date(date).toLocaleDateString(language) : date}</p>
        </header>
        <section
          dangerouslySetInnerHTML={{ __html: post.html }}
          itemProp="articleBody"
        />
        <hr />
        <footer>
          <Bio />
        </footer>
        <DiscussionEmbed {...disqusConfig} />
      </article>
      <hr />
      {!language && (
        <nav className="blog-post-nav">
          <ul
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: `space-between`,
              listStyle: `none`,
              padding: 0,
            }}
          >
            <li>
              {previous && (
                <Link to={previous.fields.slug} rel="prev">
                  ← {previous.frontmatter.title}
                </Link>
              )}
            </li>
            <li>
              {next && (
                <Link to={next.fields.slug} rel="next">
                  {next.frontmatter.title} →
                </Link>
              )}
            </li>
          </ul>
        </nav>
      )}
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug(
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    site {
      siteMetadata {
        title
        social {
          disqusShortName
        }
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      html
      fields {
        slug
        language
      }
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
      }
    }
    previous: markdownRemark(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: markdownRemark(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`
